module.exports = __webpack_public_path__ + "static/media/Affiliate-BG_mobile_Euro.8cdb3580.webp";